import React from 'react';

interface WithdrawalInputProps {
  simulationPeriods: number;
  numberOfSimulations: number;
  onPeriodsChange: (periods: number) => void;
  onSimulationsChange: (simulations: number) => void;
}

const WithdrawalInput: React.FC<WithdrawalInputProps> = ({ 
  simulationPeriods,
  numberOfSimulations,
  onPeriodsChange, 
  onSimulationsChange 
}) => {

  const handlePeriodsChange = (value: string) => {
    const numValue = parseInt(value) || 0;
    onPeriodsChange(numValue);
  };

  const handleSimulationsChange = (value: string) => {
    const numValue = parseInt(value) || 0;
    onSimulationsChange(numValue);
  };

  return (
    <div className="withdrawal-input">
      <h2>Simulation Parameters</h2>

      <div className="input-group">
        <label htmlFor="simulationPeriods">Simulation Period (years):</label>
        <input
          id="simulationPeriods"
          type="number"
          value={simulationPeriods}
          onChange={(e) => handlePeriodsChange(e.target.value)}
          placeholder="Enter number of years"
          min="1"
          max="50"
          step="1"
        />
        <small>Number of years to simulate (e.g., 30 = 30 years)</small>
      </div>

      <div className="input-group">
        <label htmlFor="numberOfSimulations">Number of Simulations:</label>
        <input
          id="numberOfSimulations"
          type="number"
          value={numberOfSimulations}
          onChange={(e) => handleSimulationsChange(e.target.value)}
          placeholder="Enter number of simulations"
          min="100"
          max="10000"
          step="100"
        />
        <small>More simulations provide more accurate results but take longer to compute</small>
      </div>
    </div>
  );
};

export default WithdrawalInput;
